import { FC, HTMLAttributes } from 'react'
import cn from 'classnames'

export const TitleText: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => (
  <div className={cn('text-primary-base w-full text-center text-2xl leading-tight font-bold', className)}>
    {children}
  </div>
)
